export default __webpack_public_path__ + "leftarrow1d1469.svg";